export default __webpack_public_path__ + "static/media/baseline-calendar_today.c398ca3f.svg";